<!--
 * @Date: 2020-05-26 10:13:36
 * @LastEditors: 黄栋
 * @LastEditTime: 2020-06-01 11:03:17
 * @FilePath: /xy-pc/src/views/login/agreement.vue
--> 
<template>
  <div class="agreement">
    <div class="agreement-box">
      <h1 class="title">签订协议申请入驻教程</h1>
      <p class="explain">教育会根据协议，保障您的合法权益</p>
      <div class="steps">
        <el-steps :active="active" simple class="step-cont">
          <el-step title="签订协议" icon="el-icon-edit"></el-step>
          <el-step title="个人信息" icon="el-icon-upload"></el-step>
          <el-step title="官网审核" icon="el-icon-picture"></el-step>
        </el-steps>
      </div>
      <div class="content" v-if="active==0">
        <!-- 步骤一  协议 -->
        <div v-html="value"></div>
        <div class="check">
          <el-checkbox v-model="checked">
            我已阅读并接受
            <el-button type="text">《检测站服务协议》</el-button>
          </el-checkbox>
        </div>
        <!-- <div class="next" @click="nextStep">下一步</div> -->
        <div style="text-align:center">
          <el-button type="primary" :disabled="!checked" @click="nextStep">下一步</el-button>
        </div>
      </div>
      <!-- -----------------------------结束----------------------------------- -->

      <!-- 步骤一二 信息 -->
      <div v-if="active==2" class="content" style="height:714px">
        <div class="shenhe">
          <img src="../../assets/image/shenhe.png" alt srcset />
        </div>
        <p class="shenhe-txt">您提交的资料正在审核中，请耐心等待！</p>
      </div>
      <!-- -----------------------------结束----------------------------------- -->

      <!-- 步骤一三 审核 身份为检测站 -->
      <div v-if="active==1 && type==0" class="content">
        <div class="form-title">
          <span class="title-left"></span>
          <span class="title-cont">基本信息</span>
        </div>
        <el-form
          size="small"
          ref="editForm"
          :rules="dataRule"
          :model="editForm"
          label-width="180px"
        >
          <el-form-item label="检测站名称：" prop="real_name">
            <el-input v-model="editForm.real_name"></el-input>
          </el-form-item>
          <el-form-item label="检测站图片：" prop="company_logo">
            <el-upload
              class="avatar-uploader"
              :action="action"
              :show-file-list="false"
              :data="uploadData"
              :on-change="(res)=>imgPreview(res,'company_logo_base')"
              :on-success="handleLogoSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <el-avatar v-if="editForm.company_logo" :src="editForm.company_logo_base" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="联系地址：" prop="country">
            <!-- <el-input type="email" v-model="editForm.contact_name"></el-input> -->

            <div style="over-flow:hidden">
              <el-select
                style="margin-right:10px"
                v-model="province"
                @change="updateProvince"
                placeholder="选择省份"
              >
                <el-option
                  v-for="item in areaData"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <el-select
                style="margin-right:10px"
                v-model="city"
                @change="updateProvince"
                placeholder="选择市"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <el-select style="margin:0" v-model="editForm.country" placeholder="选择区">
                <el-option
                  v-for="item in countryList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="详细地址：" prop="detail">
            <el-input type="email" v-model="editForm.detail"></el-input>
          </el-form-item>
          <el-form-item label="资质认定证书照片：" prop="qualification_certificate">
            <el-upload
              class="avatar-uploader"
              :action="action"
              :show-file-list="false"
              :data="uploadData"
              :on-success="handleZiZhiSuccess"
              :on-change="(res)=>imgPreview(res,'qualification_certificate_revew')"
              :before-upload="beforeAvatarUpload"
            >
              <el-image
                v-if="editForm.qualification_certificate"
                :src="editForm.qualification_certificate_revew"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="营业执照照片：" prop="business_licence_image">
            <el-upload
              class="avatar-uploader"
              :action="action"
              :show-file-list="false"
              :data="uploadData"
              :on-change="(res)=>imgPreview(res,'business_licence_review')"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <el-image
                v-if="editForm.business_licence_image"
                :src="editForm.business_licence_review"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="简介：" prop="introduce">
            <el-input v-model="editForm.introduce" type="textarea"></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align:center">
          <el-button type="primary" @click="changeStation">提交资料</el-button>
        </div>
      </div>
      <!-- -----------------------------结束----------------------------------- -->

      <!-- 步骤一三 审核 身份为专家 -->
      <div v-if="active==1 && type==1" class="content">
        <div class="form-title">
          <span class="title-left"></span>
          <span class="title-cont">基本信息</span>
        </div>
        <div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item label="真实姓名：" prop="name">
              <el-input
                v-model="ruleForm.name"
                style="width:690px"
                placeholder="真实姓名，需与身份证一致，是您提现的必要条件"
              ></el-input>
            </el-form-item>
            <el-form-item label="讲师照片：" prop="name">
              <el-upload action="#" list-type="picture-card" :auto-upload="false">
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleDownload(file)"
                    >
                      <i class="el-icon-download"></i>
                    </span>
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
            </el-form-item>
            <el-form-item label="手机号码：" prop="phone">
              <el-input v-model="ruleForm.name" style="width:690px" placeholder="请输入手机号码"></el-input>
            </el-form-item>
            <el-form-item label="邮箱：" prop="name">
              <el-input v-model="ruleForm.name" style="width:690px" placeholder="将用于学院管家联系您，请如实填写"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="form-title">
          <span class="title-left"></span>
          <span class="title-cont">身份信息</span>
        </div>
        <el-form>
          <el-form-item label="身份证正面：" prop="name">
            <el-upload action="#" list-type="picture-card" :auto-upload="false">
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    v-if="!disabled"
                    class="el-upload-list__item-delete"
                    @click="handleDownload(file)"
                  >
                    <i class="el-icon-download"></i>
                  </span>
                  <span
                    v-if="!disabled"
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </el-form-item>
          <el-form-item label="身份证反面：" prop="name">
            <el-upload action="#" list-type="picture-card" :auto-upload="false">
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    v-if="!disabled"
                    class="el-upload-list__item-delete"
                    @click="handleDownload(file)"
                  >
                    <i class="el-icon-download"></i>
                  </span>
                  <span
                    v-if="!disabled"
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt />
            </el-dialog>
          </el-form-item>
          <el-form-item label="身份证号：" prop="phone">
            <el-input v-model="ruleForm.name" style="width:690px" placeholder="需与身份证保持一致"></el-input>
          </el-form-item>
          <el-form-item label="常住地址：" prop="phone">
            <el-select v-model="value1" placeholder="选择省份">
              <el-option
                v-for="item in areaData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-select v-model="value1" placeholder="选择市">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select v-model="value1" placeholder="选择区">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细地址：" prop="phone">
            <el-input v-model="ruleForm.name" style="width:690px" placeholder="请输入详细地址"></el-input>
          </el-form-item>
          <div class="form-title">
            <span class="title-left"></span>
            <span class="title-cont">个人经历</span>
          </div>
          <el-form-item label="主讲项目：" prop="phone">
            <el-select v-model="value1" placeholder="选择第一分类">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select v-model="value1" placeholder="选择第二分类">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="教师职称：" prop="phone">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="讲师比较被人认可的头衔"
              style="width:494px"
              v-model="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item label="擅长领域：" prop="phone">
            <el-input
              type="textarea"
              :rows="2"
              style="width:494px"
              placeholder="简介尽可能提现您的主攻技术方向"
              v-model="textarea"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="next" @click="next">提交资料</div>
      </div>
      <!-- -----------------------------结束----------------------------------- -->
    </div>
  </div>
</template>
<script>
export default {
  name: "OnlineClass",

  data() {
    return {
      checked: false,
      action: window.baseUrl + "/api/v1/upload",
      uploadData: { folder: "images" },
      type: 0,
      editForm: {
        address: "", //安徽合肥市庐阳区
        province_id: "",
        city_id: "",
        area_id: "",
        avatar: "",
        introduce: "",
        company_logo_base: "",
        qualification_certificate_revew: "",
        business_licence_review: "",
        business_licence_image: "",
        business_licence_no: "",
        qualification_certificate: "",
        company_logo: "",
        contact_mobile: "",
        contact_name: "",
        contact_qq: "",
        contact_tel: "",
        detail: "",
        email: "",
        is_vip: false,
        mobile: "",
        country: "",
        perfect_user_info: true,
        real_name: "",
        status: "",
        type: "",
        vip_invalid_at: ""
      },

      province: "",
      areaData: [],
      dataRule: {
        real_name: {
          required: true,
          message: "请输入检测站名称",
          trigger: "blur"
        },
        company_logo: {
          required: true,
          message: "请上传检测站图片",
          trigger: "blur"
        },
        country: {
          required: true,
          message: "请选择检测站所在地",
          trigger: "blur"
        },
        detail: { required: true, message: "请输入详细地址", trigger: "blur" },
        business_licence_image: {
          required: true,
          message: "请上传营业执照照片",
          trigger: "blur"
        },
        introduce: {
          required: true,
          message: "请输入简介",
          trigger: "blur"
        },
        qualification_certificate: {
          required: true,
          message: "请上传资质认定证书照片",
          trigger: "blur"
        }
      },
      ruleForm: {
        name: "",
        phone: ""
      },
      values: [],
      areaProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        }
      ],
      province: "",
      city: "",
      country: "",
      cityList: [],
      countryList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      rules: {
        name: [
          {
            required: true,
            message: "真实姓名，需与身份证一致，是您提现的必要条件",
            trigger: "blur"
          },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "change" }
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change"
          }
        ],
        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change"
          }
        ],
        resource: [
          { required: true, message: "请选择活动资源", trigger: "change" }
        ],
        desc: [{ required: true, message: "请填写活动形式", trigger: "blur" }]
      },
      active: 0,
      value1: "",
      value: "<p>  </p>"
    };
  },

  watch: {
    province() {
      let list = this.areaData.filter(item => item.id == this.province);
      if (list && list[0]) {
        this.cityList = list[0].children;
        this.city = "";
      }
    },
    city() {
      let list = this.cityList.filter(item => item.id == this.city);
      if (list && list[0]) {
        this.countryList = list[0].children;
        this.country = "";
        this.editForm.country = "";
      }
    }
  },
  created() {
    this.getAreaData();
  },

  methods: {
    getAreaData() {
      this.$http({
        url: "api/v1/areas",
        method: "get"
      }).then(res => {
        if (res.status == 200) {
          this.areaData = res.data.areas;
        } else {
          this.$message.error(res.msg);
        }
      });
      this.$http({
        url: "/api/v1/configs/value",
        method: "get",
        params: { name: "station_privacy_policy" }
      }).then(res => {
        if (res.status == 200) {
          if (res.data.value) {
            this.value = res.data.value;
          }
        }
      });
    },
    updateProvince() {
      let list = this.areaData.filter(item => item.id == this.province);
      if (list && list[0]) {
        this.cityList = list[0].children;
        let citylist = this.cityList.filter(item => item.id == this.city);
        if (citylist && citylist[0]) {
          this.countryList = citylist[0].children;
          // this.country = "";
          let countryExt = this.countryList.filter(
            item => item.id == this.country
          );
          if (countryExt && countryExt[0]) {
          } else {
            this.country = "";
          }
        } else {
          this.country = "";
          this.city = "";
          this.countryList = [];
        }
      }
    },
    imgPreview(file, name) {
      console.log(file.raw);
      const thisVue = this;

      const reader = new FileReader(); // 创建读取文件对象
      reader.readAsDataURL(file.raw); // 发起异步请求，读取文件
      reader.onload = function() {
        // 文件读取完成后
        // 读取完成后，将结果赋值给img的src
        // console.log(reader)
        thisVue.editForm[name] = reader.result;
      };
    },
    next() {
      if (this.active++ > 2) this.active = 0;
    },
    handleZiZhiSuccess(res, file) {
      if (res.status == 200) {
        this.editForm = Object.assign({}, this.editForm, {
          qualification_certificate: res.data.url
        });
        this.qualificationChange = true;
      } else {
        this.$message.error(res.msg);
      }
    },
    nextStep() {
      if (!this.checked) {
        this.$message.error("请阅读并接受《服务条款》");
        return false;
      }
      if (this.active++ > 2) this.active = 0;
    },
    uploadFile() {},
    handleChange() {},
    handleRemove(file) {
      console.log(file);
    },

    changeStation() {
      this.$refs["editForm"].validate(valid => {
        if (valid) {
          this.$http({
            url: "api/v1/auth/user/station/profile",
            method: "PUT",
            params: {
              company_logo: this.editForm.company_logo,
              province_id: this.province,
              real_name: this.editForm.real_name,
              city_id: this.city,
              area_id: this.editForm.country,
              detail: this.editForm.detail,
              business_licence_image: this.editForm.business_licence_image,
              introduce: this.editForm.introduce,
              qualification_certificate: this.editForm.qualification_certificate
            }
          }).then(res => {
            if (res.status == 200) {
              this.$message.success(res.msg);
              this.active = 2;
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    beforeAvatarUpload(file) {
      console.log(file);
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    handleLogoSuccess(res, file) {
      if (res.status == 200) {
        this.editForm = Object.assign({}, this.editForm, {
          company_logo: res.data.url
        });
        this.logoChange = true;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleAvatarSuccess(res, file) {
      if (res.status == 200) {
        this.editForm = Object.assign({}, this.editForm, {
          business_licence_image: res.data.url
        });

        this.licenceChange = true;
      } else {
        this.$message.error(res.msg);
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    }
  }
};
</script>
<style lang="less" scoped>
.agreement-box {
  padding-top: 68px;
  width: 1038px;
  margin: 0 auto;
}
.title {
  text-align: center;
  font-size: 32px;
}
.explain {
  text-align: center;
  color: rgba(80, 80, 80, 1);
  font-size: 22px;
  margin-top: 33px;
  margin-bottom: 70px;
}
.steps {
  font-size: 14px;
  width: 100%;
  height: 100px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 14px;
  border: rgba(0, 0, 0, 0.1785714285714286) solid 1px;
  margin-bottom: 33px;
  overflow: hidden;
}
.step-cont {
  height: 100px;
  border-radius: 14px;
  background-color: #fff;
}
.content {
  padding: 45px;
  width: 100%;
  border: rgba(0, 0, 0, 0.1785714285714286) solid 1px;
  margin-bottom: 200px;
}
.check {
  width: 180px;
  margin: 0 auto;
  margin-bottom: 30px;
  margin-top: 30px;
}
.next {
  width: 125px;
  line-height: 42px;
  color: rgba(255, 255, 255, 1);
  background-color: rgba(42, 130, 228, 0.5);
  border-radius: 29px;
  font-size: 14px;
  text-align: center;
  margin: 0 auto;
  cursor: pointer;
}
.form-title {
  margin-bottom: 40px;
  color: rgba(0, 0, 0, 1);
  font-size: 22px;
  height: 30px;
  .title-left {
    display: block;
    float: left;
    width: 8px;
    height: 22px;
    background-color: rgba(42, 130, 228, 1);
    border-radius: 4px;
    margin-top: 4px;
    margin-right: 10px;
  }
  .title-cont {
    display: block;
    line-height: 30px;
  }
}
.el-select {
  margin-right: 19px;
}
.shenhe {
  width: 282px;
  height: 154px;
  margin: 0 auto;
  margin-top: 150px;
  img {
    width: 282px;
    height: 154px;
  }
}
.shenhe-txt {
  text-align: center;
  color: rgba(80, 80, 80, 1);
  font-size: 16px;
}
.el-step {
  width: 33% !important;
}
</style>